<template lang="html">
<ResponseQuotesPage />
</template>

<script>
import ResponseQuotesPage from '@/components/tables/ResponseQuotesTable.vue';

export default {
    components: {
        ResponseQuotesPage
    },
    data: () => {
        return {};
    }
};
</script>

<style lang="scss" scoped></style>
